<ng-container *ngIf="state$ | async as state">
  <nav class="navbar navbar-fixed-top flyout2"
       data-cy="navigation"
       data-shop-context="false"
  >
    <div class="container">
      <mb-category-navigation-logo (logoClick)="close($event, true)"></mb-category-navigation-logo>
      <mb-category-navigation-categories [selectedCategory]="state.selectedCategory"
                                         (categoryClick)="toggleSelectedCategory($event.category, $event.event)"
      ></mb-category-navigation-categories>
      <mb-category-navigation-tools-desktop (sendGTMEvent)="sendGTMEvent($event)"
                                            (searchClick)="toggleSearch()"
                                            (mobileMenuClick)="toggleMobileNavigation()"
                                            (contactClick)="toggleContact($event)"
                                            [showSearch]="showSearch"
      ></mb-category-navigation-tools-desktop>
    </div>
    <div class="container flyout2-container">
      <div class="flyout2-content">
        <div [attr.data-color]="state.selectedCategory?.label !== products ? orange : getSelectedCategoryColor()"
             [class.open]="state.isMobile ? state.isMobileNavigationOpened : !!state.selectedCategory"
             class="flyout2-columns"
             data-cy="navigation-flyout"
        >
          <mb-category-navigation-first-level [activeFilter]="state.activeFilter"
                                              [selectedCategory]="state.selectedCategory"
                                              [selectedFilter]="state.selectedFilter"
                                              (filterClick)="toggleSelectedFilter($event.filter, $event.event)"
                                              (triggerClose)="close($event, true)"
          ></mb-category-navigation-first-level>

          <mb-category-navigation-second-level [selectedCategory]="state.selectedCategory"
                                               [activeFilter]="state.activeFilter"
                                               [dataFiltered]="state.dataFiltered"
                                               [activeSubCategory]="state.activeSubCategory"
                                               [selectedSubCategories]="state.selectedSubCategories"
                                               [isSubCategorySelected]="state.isSubCategorySelected"
                                               (closeEvent)="close($event, true)"
                                               (subCategoryClick)="toggleSelectedSubCategory($event.event, $event.category, $event.subCategory, $event.additionalIdentifier)"
          ></mb-category-navigation-second-level>

          <mb-category-navigation-third-level [selectedSubCategories]="state.selectedSubCategories"
                                              [activeSubCategory]="state.activeSubCategory"
                                              [activeFilter]="state.activeFilter"
                                              [selectedCategory]="state.selectedCategory"
                                              [isSubCategorySelected]="state.isSubCategorySelected"
                                              (closeEvent)="close($event, true)"
          ></mb-category-navigation-third-level>

          <mb-category-navigation-fourth-level [isSubCategorySelected]="state.isSubCategorySelected"
                                               [activeSubCategory]="state.activeSubCategory"
                                               (closeEvent)="close($event, true)"
          ></mb-category-navigation-fourth-level>
        </div>
      </div>
    </div>
    <div class="container tools-mobile">
      <mb-category-navigation-tools-mobile [isMobileNavigationOpened]="state.isMobileNavigationOpened"
                                           (contactClick)="toggleContact($event)"
                                           (mobileMenuClick)="toggleMobileNavigation()"
                                           (searchClick)="toggleSearch()"
                                           (sendGTMEvent)="sendGTMEvent($event)"
      ></mb-category-navigation-tools-mobile>
    </div>
    <div [class.d-lg-block]="showContact"
         class="container contact-flyout flyout-desktop d-none"
    >
      <div class="wrapper contact-wrapper contactInformation">
        <mb-contact-box-navigation (closeContact)="closeContact($event)"></mb-contact-box-navigation>
      </div>
    </div>
    <div [class.d-lg-block]="showSearch"
         class="container search-flyout flyout-desktop d-none"
    >
      <div class="wrapper search-wrapper"
           data-cy="search-wrapper"
      >
        <div class="container searchbar-standalone"
             data-invoke="SearchPreselector"
             data-options="{}"
             data-searchtype="globalSearchFamilies"
        >
          <mb-search-box-component [isInitialFocused]="showSearch"></mb-search-box-component>
        </div>
      </div>
    </div>
  </nav>
  <div [class.d-block]="state.isMobile && showSearch"
       class="container search-flyout flyout-mobile d-none-md"
  >
    <div class="wrapper search-wrapper"
         data-cy="search-wrapper"
    >
      <div class="container searchbar-standalone"
           data-invoke="SearchPreselector"
           data-options="{}"
           data-searchtype="globalSearchFamilies"
      >
      <mb-search-box-component [isInitialFocused]="showSearch"></mb-search-box-component>
      </div>
    </div>
  </div>
  <div (click)="close($event, false)"
       [class.flyout-backdrop]="showBackdrop()"
       [class.in]="showBackdrop()"
       [class.opacity05]="state.isMobile && showSearch"
       data-cy="navigation-backdrop"
  ></div>
</ng-container>

